import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import {
    Select,
    FormControl,
    InputLabel,
    MenuItem,
    Card,
    CardHeader,
    CardContent,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from 'styles/components/widgetNav.module.scss';

const WidgetNav = ({ brands }) => {
    const router = useRouter();
    const [brandSelect, setBrandSelect] = useState('all');
    const [modelSelect, setModelSelect] = useState('all');

    useEffect(() => {
        setBrandSelect('all');
        setModelSelect('all');
    }, [router.asPath]);

    const handleSetBrandSelect = () => {
        const options = [
            <MenuItem key={0} aria-label="Toutes" value="all">
                Choisir
            </MenuItem>,
        ];
        brands.forEach((brand) => {
            options.push(
                <MenuItem value={brand.id} key={brand.id}>
                    {brand.brand}
                </MenuItem>,
            );
        });

        return options;
    };
    const handleBrandSelectChange = (event) => {
        setBrandSelect(event.target.value);
        if (event.target.value !== 'all') {
            const selected = brands.filter((brand) => {
                return brand.id === event.target.value;
            });
            router.push(`/marques-voiture/${selected[0].brand.replace(/ /g, '-')}`);
        }
    };
    const handleSetModelSelect = () => {
        const options = [
            <MenuItem key={0} aria-label="Tous" value="all">
                Choisir
            </MenuItem>,
        ];
        brands.forEach((brand) => {
            brand.models.forEach((mod) => {
                options.push(
                    <MenuItem value={mod.id} key={mod.id}>
                        {`${brand.brand} ${mod.model}`}
                    </MenuItem>,
                );
            });
        });

        return options;
    };
    const handleModelSelectChange = (event) => {
        setModelSelect(event.target.value);
        if (event.target.value !== 'all') {
            let selectedModel = [];
            brands.forEach((brand) => {
                if (selectedModel.length === 0) {
                    selectedModel = brand.models.filter((mod) => {
                        return mod.id === event.target.value;
                    });
                    if (selectedModel.length === 1) {
                        selectedModel[0].brand = brand.brand;
                    }
                }
            });
            router.push(
                `/modeles-voiture/${selectedModel[0].brand.replace(
                    / /g,
                    '-',
                )}/${selectedModel[0].model.replace(/ /g, '-')}`,
            );
        }
    };
    return (
        <div className={styles.root}>
            <Card className={styles.cardRoot}>
                <CardHeader title={<h2>Accès rapide marque & modèle</h2>} />
                <CardContent className={styles.cardContent}>
                    <form>
                        <FormControl variant="outlined">
                            <InputLabel id="brand-select-label">
                                Choisir marque
                            </InputLabel>
                            <Select
                                labelId="brand-select-label"
                                id="brand-select"
                                name="brand"
                                label="Choisir marque"
                                value={brandSelect}
                                onChange={handleBrandSelectChange}
                                variant="outlined"
                            >
                                {handleSetBrandSelect()}
                            </Select>
                            <span id="no_cat_search" className="form_error" />
                        </FormControl>
                    </form>
                    <form>
                        <FormControl variant="outlined">
                            <InputLabel id="model-select-label">
                                Choisir modèle
                            </InputLabel>
                            <Select
                                labelId="model-select-label"
                                id="model-select"
                                name="model"
                                label="Choisir modèle"
                                value={modelSelect}
                                onChange={handleModelSelectChange}
                                variant="outlined"
                            >
                                {handleSetModelSelect()}
                            </Select>
                            <span id="no_cat_search" className="form_error" />
                        </FormControl>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
};

WidgetNav.propTypes = {
    brands: PropTypes.array.isRequired,
};

export default React.memo(WidgetNav);
